import { useEffect, useState } from 'react'
import { Main, Control, Text } from './NoSnapSeasonSlider.style'
import { Track } from 'components/SliderTrack/SliderTrack'
import { getFocus, useGet, useSet } from 'state/jotai'
import { active_project, iso_free, iso_isrotating } from 'state/store.global'
import { vis_overlay } from 'state/store.global'
import { motion } from 'framer-motion'
import { _project } from 'state/store.projects'
import { SeasonSliderThumb } from 'components/SliderThumb/SeasonSliderThumb'
import { timeInterval } from 'utilities/utility.timeInterval'
import { useBreak } from 'hooks/useBreak'
import { Mode360 } from 'components/IsometryRotation/360'
import { getIsoData, getSeasonIsoData } from 'state/jotai.isometryDataHooks'
import { _seasons_isometry } from 'state/store.season'

export const SeasonsNoSnapSlider = ({ frame, setFrame, config, index, setIndex }) => {

  const { pin, pid }        = useGet(active_project);
  const season     = getFocus(_seasons_isometry, 'season_type');
  const activeIsometryFrame = getIsoData("activeframe");
  const rmode       = useGet(iso_free)
  
  const seasonType = season?.[pin]?.[pid]?.[activeIsometryFrame]?.type;
 
  const isMobile = useBreak('md_dn')

  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const animation = {
    initial   : { opacity: 0 },
    animate   : { opacity: 1 },
    exit      : { opacity: 0 },
    transition: { duration: 0.3, ease: 'linear' },
  }

  const ini   = config.FIRST_IMAGE
  const max   = config.FIRST_IMAGE + config.IMAGE_NUM - 1
  const end   = config.IMAGE_NUM - 1
  const marks = config.IMAGE_SNAPFRAMES
  
  const sliderIndex = frame - ini

  // Number of frames
  const numberOfFrames = max - ini;
  const totalSec       = numberOfFrames/10;

  const season_activeIsometryFrame = getSeasonIsoData("activeframe")

   
  const [render, setRender] = useState(false)
  const setOverlay          = useSet(vis_overlay)
  const setRotate           = useSet(iso_isrotating)
  const change              = v => {
    const d_fr = { ...season_activeIsometryFrame, [activeIsometryFrame]: {...season_activeIsometryFrame[activeIsometryFrame], [seasonType]: v}}
    setFrame(d_fr)
  }

  useEffect(() => {
    let timeout = setTimeout(() => {
      setRender(true)
    }, 2000)
    setOverlay(false)
    return () => {
      setOverlay(true)
      clearTimeout(timeout)
    }
  }, [])


  const seasonTime = {
    "fall": "07:41",
    "summer": "04:47",
    "winter": "08.29",
    "spring": "06.03"
  }
  
  const endTime = timeInterval(seasonTime[seasonType], 30, (end+1)/30, 'minutes', 'H.mm');

  if (!isNaN(end))
    return (
      <div style = {{ display: "flex", flexWrap: "wrap"}}>
      <div style = {{ display: "flex", flex: "1" }} >
        <Main
        {...animation}
        onTouchStart = {() => setRotate(false)}
        onTouchMove  = {() => setRotate(false)}
          // onMouseDown        = {()=>setRotate(false)}
          // onClick            = {()=>setRotate(false)}
        onMouseDownCapture = {() => setRotate(false)}
      >
        {/* { render && ( */}
          <motion.div {...animation} style = {{width: '100%', display: "flex", gap: isMobile ? "10px" : "16px", justifyContent: 'center'}}>
          { !isMobile && <div        style                = {{display: "flex", alignItems: "end", width:'8%', justifyContent: "center", flexDirection: "column"}}>
            <div        style                = {{ fontWeight: "500", fontSize: "14px", lineHeight: "18px" }}>
              <div        style                = {{ fontWeight: "600" }}>{buttonsLabel?.filter( btn => btn.UILabelProperty === 'Solopgang')[0]?.Label}:</div>
              <div        style                = {{ textAlign: "center" }}>{seasonTime[seasonType]}</div>
            </div>
          </div>
          }
            <Control
            isMobile={isMobile}
              value         = {frame}
              defaultValue  = {frame}
              renderTrack   = {Track}
              renderThumb   = {(props)=> <SeasonSliderThumb props={props} index={sliderIndex} />}
              step          = {1}
              max           = {max}
              min           = {ini}
              marks         = {[...marks]}
              onSliderClick = {() => setRotate(false)}
              onChange      = {change}
            />
            { !isMobile &&
              <div style = {{display: "flex", alignItems: "start", width:'8%', justifyContent: "flex-start", gap: "20px" }}>
                  <div style = {{ fontWeight: "500", fontSize: "14px", lineHeight: "18px" }}>
                    <div style = {{ fontWeight: "600" }}>{buttonsLabel?.filter( btn => btn.UILabelProperty === 'Solnedgang')[0]?.Label}:</div>
                    <div style = {{ textAlign: "center" }}>{endTime}</div>
                </div>
            </div> 
            }
          </motion.div>
        {/* )} */}
      </Main>
        </div>
      </div>
    )
}
// left: '-5%', bottom: '144px'